import BaseReportRepository from './baseReportRepository'
import WrappedReportRepository from './wrappedReportRepository'

export default {
    BaseReportRepository,
    WrappedReportRepository
}
